// The badge column that used to sit right of the title moved to slide 2's
// at-a-glance strip (TPF, 2026-09-01) — the cover carries identity and
// contacts only. The wordmark sits under the title rather than in a header
// (TPF, 2026-09-02): wordmark + straplines form the header block; the deck
// title sits in the vertically-centred body.
export default function Cover() {
  return (
    <div className="flex w-full flex-col gap-10 px-6 pt-10 pb-5 text-slate-900 md:h-full md:gap-0 md:px-24 md:pt-16 md:pb-8">
      <header className="flex flex-col">
        <img
          src="https://public.apptonomy.ai/a7y-wordmark-onlight.png"
          srcSet="https://public.apptonomy.ai/a7y-wordmark-onlight.png 1x, https://public.apptonomy.ai/a7y-wordmark-onlight_2x.png 2x, https://public.apptonomy.ai/a7y-wordmark-onlight_3x.png 3x"
          alt="Apptonomy"
          className="h-9 w-auto self-start md:h-12"
        />
        <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-600 md:mt-4 md:text-xs md:tracking-[0.2em]">
          The Constant ASO Platform
        </p>
        <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-600 md:mt-1 md:text-xs md:tracking-[0.2em]">
          Expert ASO. Every app. Every day.
        </p>
      </header>

      <div className="flex flex-col md:flex-1 md:justify-center">
        <h1 className="text-4xl font-semibold leading-tight tracking-tight md:text-7xl md:leading-[1.05]">
          Pre-Seed Fundraise
        </h1>
        <p className="mt-3 text-lg font-medium tracking-tight text-slate-500 md:mt-4 md:text-2xl">
          Q4 2026
        </p>
      </div>

      <footer className="flex flex-col gap-4 text-sm md:flex-row md:gap-16 md:text-lg">
        <div>
          <p className="font-semibold text-slate-800">Thomas Purnell-Fisher, CEO</p>
          <p className="mt-1 text-slate-500">tpf@apptonomy.ai</p>
          <p className="text-slate-500">+31 (0)6 2343 9095 (NL / iMessage / WhatsApp)</p>
        </div>
        <div>
          <p className="font-semibold text-slate-800">Yevhen Tarasenko, CMO</p>
          <p className="mt-1 text-slate-500">yevhen@apptonomy.ai</p>
          <p className="text-slate-500">+34 627 896 205 (ES / iMessage / WhatsApp)</p>
        </div>
      </footer>
    </div>
  );
}
